// extracted by mini-css-extract-plugin
export default {"fadeIn":"styles_fadeIn__34eBM","fade-in":"styles_fade-in__1Ky0+","bgTigre":"styles_bgTigre__lAE0L","btnEffect":"styles_btnEffect__B+F7K"};